<template>
  <div class="personal-details">
    <div class="name">
      <p class="title">
        联系人
      </p>
      <van-field v-model="name" placeholder="请输入联系方式" />
    </div>
    <div class="name">
      <p class="title">
        联系方式
      </p>
      <van-field v-model="phone" type="tel" placeholder="请输入联系电话" />
    </div>
    <div class="name">
      <p class="title">
        身份证号码
      </p>
      <van-field v-model="id_card" type="tel" placeholder="请输入身份证号码" />
    </div>
    <div class="name">
      <p class="title">
        城市
      </p>
      <van-field v-model="phone" type="tel" placeholder="请选择归属地" />
    </div>
    <div class="post-photo">
      <p class="title">
        注意：请上传营业执照
      </p>'
      <div>

      </div>
    </div>
    <div class="next-btn" @click="$router.push('/business-contract')">

    </div>
    <contactWay></contactWay>
  </div>
</template>

<script>

import contactWay from '../../components/partner/contact-way'

import Vue from 'vue';
import { Field } from 'vant';

Vue.use(Field);

export default {
  data(){
    return{
      name: '',
      phone: '',
      id_card
    }
  },
  components:{
    contactWay
  }
}
</script>

<style lang="less" scoped>
  .personal-details{
    width: 7.1rem;
    height: 10.19rem;
    background: #ffffff;
    margin: 0 auto;
    margin-top: .1rem;
    border-radius: .1rem;
    .name{
      overflow: hidden;
      .title{
        font-size: 0.26rem;
        font-family: PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: .26rem;
        margin-top: .39rem;
        margin-left: .4rem;
      }
    }
    .post-photo{
      .title{
        font-size: 0.22rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FF491F;
        margin-left: .3rem;
        margin-top: .38rem;
      }
    }
    // 下一步按钮
    .next-btn{
      width: 2.42rem;
      height: .72rem;
      background-image: url('../../assets/images/partner-img/btn.png');
      background-size: 2.42rem .72rem;
      margin: 0 auto;
      margin-top: 1.06rem;
    }
  }
</style>